// Datos de las zonas principales de Riviera Nayarit para SEO local

export interface Zona {
  id: string;
  slug: string;
  nombre: string;
  nombreCompleto: string;
  descripcion: string;
  descripcionLarga: string;
  ubicacion: string;
  caracteristicas: string[];
  tiposPropiedades: string[];
  rangoPreciosUSD: {
    min: number;
    max: number;
  };
  puntosClave: {
    titulo: string;
    descripcion: string;
  }[];
  amenidades: string[];
  distancias: {
    aeropuerto: string;
    puertoVallarta: string;
    playa: string;
  };
  imagen: string;
  imagenes: string[];
  coordenadas: {
    lat: number;
    lng: number;
  };
  keywords: string[];
  metaDescription: string;
}

export const ZONAS_DATA: Zona[] = [
  {
    id: 'punta-de-mita',
    slug: 'punta-de-mita',
    nombre: 'Punta de Mita',
    nombreCompleto: 'Punta de Mita, Nayarit',
    descripcion: 'Destino de lujo con playas paradisíacas, campos de golf de clase mundial y resorts exclusivos.',
    descripcionLarga: 'Punta de Mita es el epicentro del turismo de lujo en Riviera Nayarit. Esta península exclusiva alberga algunos de los desarrollos inmobiliarios más prestigiosos de México, incluyendo Four Seasons, St. Regis y The W. Con sus playas de arena blanca, aguas cristalinas ideales para surf y una comunidad selecta de residentes internacionales, Punta de Mita representa la cúspide del mercado inmobiliario de alta gama en la costa del Pacífico.',
    ubicacion: 'Extremo noroeste de Bahía de Banderas',
    caracteristicas: [
      'Playas vírgenes de arena blanca',
      'Campos de golf Pacífico y Bahía',
      'Resorts Four Seasons y St. Regis',
      'Puerto deportivo',
      'Comunidades cerradas de lujo'
    ],
    tiposPropiedades: ['Condominios de lujo', 'Villas', 'Residencias en campo de golf', 'Penthouses', 'Terrenos'],
    rangoPreciosUSD: {
      min: 500000,
      max: 15000000
    },
    puntosClave: [
      {
        titulo: 'Inversión Premium',
        descripcion: 'Propiedades con alta plusvalía y demanda internacional constante.'
      },
      {
        titulo: 'Estilo de Vida',
        descripcion: 'Acceso a amenidades de clase mundial: spas, restaurantes gourmet, deportes acuáticos.'
      },
      {
        titulo: 'Privacidad',
        descripcion: 'Comunidades exclusivas con seguridad 24/7 y acceso controlado.'
      }
    ],
    amenidades: ['Golf', 'Spas', 'Restaurantes gourmet', 'Marina', 'Tenis', 'Surf', 'Buceo', 'Yoga'],
    distancias: {
      aeropuerto: '45 minutos',
      puertoVallarta: '40 minutos',
      playa: 'Acceso directo'
    },
    imagen: '/assets/images/zonas/punta-de-mita.jpg',
    imagenes: [
      '/assets/images/zonas/punta-de-mita-1.jpg',
      '/assets/images/zonas/punta-de-mita-2.jpg',
      '/assets/images/zonas/punta-de-mita-3.jpg'
    ],
    coordenadas: {
      lat: 20.7667,
      lng: -105.5167
    },
    keywords: [
      'punta de mita propiedades',
      'casas punta de mita',
      'condominios punta de mita',
      'bienes raíces punta de mita',
      'inversión punta de mita',
      'real estate punta de mita'
    ],
    metaDescription: 'Propiedades de lujo en Punta de Mita, Riviera Nayarit. Condominios, villas y residencias en comunidades exclusivas como Four Seasons y St. Regis. Asesoría profesional AMPI.'
  },
  {
    id: 'sayulita',
    slug: 'sayulita',
    nombre: 'Sayulita',
    nombreCompleto: 'Sayulita, Nayarit',
    descripcion: 'Pueblo mágico bohemio, famoso por su cultura surf, ambiente artístico y gastronomía local.',
    descripcionLarga: 'Sayulita es un encantador pueblo mágico que ha conquistado el corazón de viajeros y residentes de todo el mundo. Conocido por sus olas perfectas para surfear, calles empedradas llenas de galerías de arte, boutiques y restaurantes, Sayulita ofrece un estilo de vida relajado pero vibrante. El mercado inmobiliario aquí atrae a compradores que buscan propiedades con carácter, desde casas tradicionales mexicanas hasta modernos condominios con vista al mar.',
    ubicacion: 'Norte de Bahía de Banderas, a 40 km de Puerto Vallarta',
    caracteristicas: [
      'Pueblo Mágico certificado',
      'Cultura surf reconocida mundialmente',
      'Gastronomía local y gourmet',
      'Arte y artesanías',
      'Comunidad expat activa'
    ],
    tiposPropiedades: ['Casas tradicionales', 'Condominios boutique', 'Terrenos', 'Locales comerciales', 'Propiedades para renta vacacional'],
    rangoPreciosUSD: {
      min: 200000,
      max: 3000000
    },
    puntosClave: [
      {
        titulo: 'Renta Vacacional',
        descripcion: 'Alta demanda de alquiler turístico con excelente ROI.'
      },
      {
        titulo: 'Comunidad Vibrante',
        descripcion: 'Mix perfecto de cultura mexicana y comunidad internacional.'
      },
      {
        titulo: 'Crecimiento Sostenido',
        descripcion: 'Plusvalía constante gracias al atractivo turístico.'
      }
    ],
    amenidades: ['Surf', 'Yoga', 'Restaurantes', 'Vida nocturna', 'Mercados locales', 'Galerías de arte'],
    distancias: {
      aeropuerto: '55 minutos',
      puertoVallarta: '40 minutos',
      playa: '5 minutos caminando'
    },
    imagen: '/assets/images/zonas/sayulita.jpg',
    imagenes: [
      '/assets/images/zonas/sayulita-1.jpg',
      '/assets/images/zonas/sayulita-2.jpg',
      '/assets/images/zonas/sayulita-3.jpg'
    ],
    coordenadas: {
      lat: 20.8686,
      lng: -105.4403
    },
    keywords: [
      'sayulita propiedades',
      'casas sayulita',
      'bienes raíces sayulita',
      'inversión sayulita',
      'sayulita real estate',
      'propiedades pueblo mágico'
    ],
    metaDescription: 'Propiedades en Sayulita, Pueblo Mágico de Riviera Nayarit. Casas, condominios y terrenos en la meca del surf mexicano. Asesoría inmobiliaria certificada AMPI.'
  },
  {
    id: 'bucerias',
    slug: 'bucerias',
    nombre: 'Bucerías',
    nombreCompleto: 'Bucerías, Nayarit',
    descripcion: 'Pueblo tradicional con la playa más larga de la bahía, perfecto balance entre autenticidad y comodidad.',
    descripcionLarga: 'Bucerías ofrece lo mejor de dos mundos: la autenticidad de un pueblo mexicano tradicional con todas las comodidades modernas. Su extensa playa de más de 3 km es perfecta para caminatas al atardecer, mientras que su centro histórico alberga mercados de artesanías, restaurantes de mariscos frescos y una creciente escena gastronómica. El mercado inmobiliario de Bucerías atrae a familias y jubilados que buscan calidad de vida a precios más accesibles que otras zonas de la bahía.',
    ubicacion: 'Centro de Bahía de Banderas, entre Nuevo Vallarta y La Cruz',
    caracteristicas: [
      'Playa más larga de la bahía (3+ km)',
      'Mercado de artesanías tradicional',
      'Restaurantes de mariscos frescos',
      'Comunidad de jubilados activa',
      'Precios más accesibles'
    ],
    tiposPropiedades: ['Condominios frente al mar', 'Casas tradicionales', 'Townhouses', 'Terrenos', 'Propiedades comerciales'],
    rangoPreciosUSD: {
      min: 150000,
      max: 2000000
    },
    puntosClave: [
      {
        titulo: 'Valor por Dinero',
        descripcion: 'Propiedades frente al mar a precios competitivos.'
      },
      {
        titulo: 'Vida Auténtica',
        descripcion: 'Experiencia mexicana genuina con comodidades modernas.'
      },
      {
        titulo: 'Ubicación Central',
        descripcion: 'Acceso fácil a todas las atracciones de la bahía.'
      }
    ],
    amenidades: ['Playa extensa', 'Mercados locales', 'Restaurantes', 'Centros de salud', 'Supermercados', 'Bancos'],
    distancias: {
      aeropuerto: '25 minutos',
      puertoVallarta: '25 minutos',
      playa: 'Acceso directo'
    },
    imagen: '/assets/images/zonas/bucerias.jpg',
    imagenes: [
      '/assets/images/zonas/bucerias-1.jpg',
      '/assets/images/zonas/bucerias-2.jpg',
      '/assets/images/zonas/bucerias-3.jpg'
    ],
    coordenadas: {
      lat: 20.7536,
      lng: -105.3347
    },
    keywords: [
      'bucerias propiedades',
      'casas bucerias',
      'condominios bucerias',
      'bienes raíces bucerias',
      'inversión bucerias',
      'bucerias real estate'
    ],
    metaDescription: 'Propiedades en Bucerías, Riviera Nayarit. Condominios frente al mar, casas tradicionales y terrenos en un pueblo auténtico mexicano. Asesoría profesional AMPI.'
  },
  {
    id: 'nuevo-vallarta',
    slug: 'nuevo-vallarta',
    nombre: 'Nuevo Vallarta',
    nombreCompleto: 'Nuevo Vallarta, Nayarit',
    descripcion: 'Desarrollo turístico integral con marina, campos de golf, hoteles all-inclusive y condominios modernos.',
    descripcionLarga: 'Nuevo Vallarta es el desarrollo turístico más completo de Riviera Nayarit. Con su marina de clase mundial, campos de golf de campeonato, resorts all-inclusive y modernos desarrollos residenciales, ofrece un estilo de vida resort permanente. La zona es especialmente popular entre familias con niños gracias a sus amenidades, parques acuáticos y ambiente seguro. El mercado inmobiliario incluye desde condominios accesibles hasta residencias de lujo en campo de golf.',
    ubicacion: 'Sur de Bahía de Banderas, junto al aeropuerto',
    caracteristicas: [
      'Marina Paradise Village',
      'Campos de golf El Tigre y Vidanta',
      'Resorts all-inclusive',
      'Parques acuáticos',
      'Infraestructura moderna'
    ],
    tiposPropiedades: ['Condominios', 'Residencias en marina', 'Casas en campo de golf', 'Penthouses', 'Time shares'],
    rangoPreciosUSD: {
      min: 180000,
      max: 5000000
    },
    puntosClave: [
      {
        titulo: 'Infraestructura Completa',
        descripcion: 'Todo lo necesario a minutos: hospitales, escuelas, comercios.'
      },
      {
        titulo: 'Ideal para Familias',
        descripcion: 'Ambiente seguro con actividades para todas las edades.'
      },
      {
        titulo: 'Conectividad',
        descripcion: 'A 10 minutos del aeropuerto internacional.'
      }
    ],
    amenidades: ['Golf', 'Marina', 'Parques acuáticos', 'Centros comerciales', 'Hospitales', 'Escuelas internacionales'],
    distancias: {
      aeropuerto: '10 minutos',
      puertoVallarta: '20 minutos',
      playa: 'Acceso directo'
    },
    imagen: '/assets/images/zonas/nuevo-vallarta.jpg',
    imagenes: [
      '/assets/images/zonas/nuevo-vallarta-1.jpg',
      '/assets/images/zonas/nuevo-vallarta-2.jpg',
      '/assets/images/zonas/nuevo-vallarta-3.jpg'
    ],
    coordenadas: {
      lat: 20.6978,
      lng: -105.2967
    },
    keywords: [
      'nuevo vallarta propiedades',
      'casas nuevo vallarta',
      'condominios nuevo vallarta',
      'bienes raíces nuevo vallarta',
      'inversión nuevo vallarta',
      'nuevo vallarta real estate'
    ],
    metaDescription: 'Propiedades en Nuevo Vallarta, Riviera Nayarit. Condominios, casas en marina y residencias en campo de golf. Desarrollo turístico integral con asesoría AMPI.'
  },
  {
    id: 'bahia-de-banderas',
    slug: 'bahia-de-banderas',
    nombre: 'Bahía de Banderas',
    nombreCompleto: 'Bahía de Banderas, Nayarit',
    descripcion: 'Municipio que engloba toda la costa de Riviera Nayarit, desde Nuevo Vallarta hasta Punta de Mita.',
    descripcionLarga: 'Bahía de Banderas es el municipio que da nombre a una de las bahías más hermosas del mundo. Abarca toda la costa nayarita de la bahía, desde los desarrollos turísticos de Nuevo Vallarta hasta la exclusiva Punta de Mita, pasando por pueblos encantadores como Bucerías, La Cruz de Huanacaxtle y Sayulita. El municipio ofrece opciones para todos los presupuestos y estilos de vida, desde inversiones de lujo hasta propiedades residenciales accesibles.',
    ubicacion: 'Costa de Nayarit en la Bahía de Banderas',
    caracteristicas: [
      'Diversidad de comunidades',
      'Todos los rangos de precio',
      'Infraestructura en desarrollo',
      'Gobierno pro-inversión',
      'Crecimiento económico sostenido'
    ],
    tiposPropiedades: ['Todas las categorías', 'Terrenos de inversión', 'Desarrollos nuevos', 'Propiedades comerciales', 'Proyectos de preventa'],
    rangoPreciosUSD: {
      min: 100000,
      max: 15000000
    },
    puntosClave: [
      {
        titulo: 'Diversificación',
        descripcion: 'Múltiples opciones de inversión en diferentes segmentos.'
      },
      {
        titulo: 'Crecimiento',
        descripcion: 'Zona de mayor desarrollo inmobiliario en México.'
      },
      {
        titulo: 'Conectividad',
        descripcion: 'Aeropuerto internacional y conexiones terrestres.'
      }
    ],
    amenidades: ['Playas', 'Golf', 'Marina', 'Hospitales', 'Escuelas', 'Centros comerciales', 'Restaurantes'],
    distancias: {
      aeropuerto: '10-45 minutos según zona',
      puertoVallarta: '15-45 minutos según zona',
      playa: 'Todas las comunidades con acceso'
    },
    imagen: '/assets/images/zonas/bahia-de-banderas.jpg',
    imagenes: [
      '/assets/images/zonas/bahia-de-banderas-1.jpg',
      '/assets/images/zonas/bahia-de-banderas-2.jpg',
      '/assets/images/zonas/bahia-de-banderas-3.jpg'
    ],
    coordenadas: {
      lat: 20.7500,
      lng: -105.4000
    },
    keywords: [
      'bahia de banderas propiedades',
      'inmobiliarias bahia de banderas',
      'bienes raíces bahia de banderas',
      'inversión bahia de banderas',
      'bahia de banderas real estate',
      'propiedades nayarit'
    ],
    metaDescription: 'Propiedades en Bahía de Banderas, Riviera Nayarit. Desde Nuevo Vallarta hasta Punta de Mita. Todas las opciones de inversión inmobiliaria con asesoría AMPI certificada.'
  },
  {
    id: 'la-cruz-de-huanacaxtle',
    slug: 'la-cruz-de-huanacaxtle',
    nombre: 'La Cruz de Huanacaxtle',
    nombreCompleto: 'La Cruz de Huanacaxtle, Nayarit',
    descripcion: 'Pueblo pesquero transformado con marina moderna, mercado de pescadores y comunidad internacional.',
    descripcionLarga: 'La Cruz de Huanacaxtle ha experimentado una transformación notable en las últimas décadas. De pueblo pesquero tradicional a destino sofisticado con una marina de clase mundial, La Cruz combina lo mejor de ambos mundos. El famoso mercado de pescadores de los domingos atrae a visitantes de toda la bahía, mientras que la Marina Riviera Nayarit alberga yates de lujo y restaurantes gourmet. El mercado inmobiliario ofrece excelente valor con potencial de plusvalía significativo.',
    ubicacion: 'Norte de Bucerías, sur de Punta de Mita',
    caracteristicas: [
      'Marina Riviera Nayarit',
      'Mercado de pescadores dominical',
      'Pueblo tradicional preservado',
      'Comunidad internacional creciente',
      'Excelente valor inmobiliario'
    ],
    tiposPropiedades: ['Condominios con vista a marina', 'Casas tradicionales', 'Townhouses', 'Terrenos', 'Locales comerciales'],
    rangoPreciosUSD: {
      min: 200000,
      max: 3500000
    },
    puntosClave: [
      {
        titulo: 'Potencial de Plusvalía',
        descripcion: 'Zona emergente con desarrollo acelerado.'
      },
      {
        titulo: 'Marina de Clase Mundial',
        descripcion: 'Atrae turismo náutico internacional.'
      },
      {
        titulo: 'Autenticidad',
        descripcion: 'Conserva el encanto de pueblo pesquero.'
      }
    ],
    amenidades: ['Marina', 'Mercado de pescadores', 'Restaurantes de mariscos', 'Buceo', 'Pesca deportiva', 'Yoga'],
    distancias: {
      aeropuerto: '35 minutos',
      puertoVallarta: '30 minutos',
      playa: '5-10 minutos'
    },
    imagen: '/assets/images/zonas/la-cruz.jpg',
    imagenes: [
      '/assets/images/zonas/la-cruz-1.jpg',
      '/assets/images/zonas/la-cruz-2.jpg',
      '/assets/images/zonas/la-cruz-3.jpg'
    ],
    coordenadas: {
      lat: 20.7528,
      lng: -105.3850
    },
    keywords: [
      'la cruz de huanacaxtle propiedades',
      'casas la cruz nayarit',
      'condominios la cruz',
      'bienes raíces la cruz',
      'marina riviera nayarit propiedades',
      'la cruz real estate'
    ],
    metaDescription: 'Propiedades en La Cruz de Huanacaxtle, Riviera Nayarit. Condominios vista marina, casas tradicionales y terrenos en pueblo pesquero con marina moderna. Asesoría AMPI.'
  }
];

// Funciones helper
export const getZonaBySlug = (slug: string): Zona | undefined =>
  ZONAS_DATA.find(z => z.slug === slug);

export const getAllZonaSlugs = (): string[] =>
  ZONAS_DATA.map(z => z.slug);

export const getZonasDestacadas = (cantidad: number = 4): Zona[] =>
  ZONAS_DATA.slice(0, cantidad);

export const getZonasPorRangoPrecio = (minUSD: number, maxUSD: number): Zona[] =>
  ZONAS_DATA.filter(z => z.rangoPreciosUSD.min >= minUSD && z.rangoPreciosUSD.max <= maxUSD);
